import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DynamicFont from '../../utility/dynamic-font'
import { REG_EXP } from '../Html/config/index'
import { parser } from '../Html/Html'
import { observer } from 'mobx-react'
import { computed, toJS, makeObservable } from 'mobx'

const Record = PropTypes.object

const style = {
  overflow: 'hidden',
  width: '100%',
  height: '100%'
}

const TRANSFORM = ['lowercase', 'uppercase', 'capitalize', 'none', 'inherit']
const ALIGN = ['center', 'start', 'end']
const BORDER_STYLES = ['dotted', 'dashed', 'solid', 'none']
const color = PropTypes.color

export const theme = {
  color: color,
  backgroundColor: color,
  fontSize: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlign: PropTypes.oneOf(ALIGN),
  textTransform: PropTypes.oneOf(TRANSFORM),
  borderColor: color,
  borderWidth: PropTypes.string,
  borderStyle: PropTypes.oneOf(BORDER_STYLES),
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string
}

const Label = observer(class Label extends Component {
  static propTypes = {
    /**
     * Text or numeric value to be displayed
     */
    value: PropTypes.string,

    /**
     * Record to display
     */
    record: Record,

    /**
     * Determines if Label's value is html formatted.
     */
    isHtml: PropTypes.bool,

    /**
     * Forces font size to shrink so that the content in value fits in the allocated space in the layout
     */
    fitText: PropTypes.bool,

    /**
     * Enable / Disable text wrap
     */
    wrapText: PropTypes.bool,

    /**
     * Adjust the colors, borders, and alignment
     */
    styling: PropTypes.shape(theme)
  }

  static defaultProps = {
    value: '',
    fitText: true,
    isHtml: false,
    wrapText: false,
    styling: {
      textAlign: 'left',
      verticalAlign: 'start'
    }
  }

  constructor (props) {
    super(props)

    makeObservable(this, {
      record: computed
    })
  }

  get record () {
    return this.props.record
  }

  render () {
    const {
      isConfig,
      styling: {
        color,
        backgroundColor,
        textAlign,
        textTransform,
        fontSize,
        padding,
        margin,
        verticalAlign,
        borderColor,
        borderWidth,
        borderStyle,
        borderRadius
      } = {},
      fitText,
      wrapText,
      isHtml
    } = this.props
    const value = this.props.value || (isConfig && 'Label Text')
    const data = toJS(this.record) || {}
    const plain = Object.assign({}, data)
    const innerHtml = (!!isHtml && parser(plain, value, REG_EXP)) || ''
    const finalStyle = {
      ...style,
      ...(!fitText && { fontSize: fontSize }),
      ...(fitText && { alignItems: `flex-start` }),
      ...(!fitText && { alignItems: verticalAlign !== `center` ? `flex-${verticalAlign}` : verticalAlign })
    }
    return (
      <div style={finalStyle} className={`label-container`}>
        <DynamicFont fitText={fitText} textAlign={fitText ? 'left' : textAlign} wrapText={wrapText} content={isHtml ? innerHtml : value} scalable={fitText} />
        <style jsx>{`
          .label-container {
            display: flex;
            margin: ${margin};
            padding: ${padding};
            text-overflow: ${fitText ? `clip` : `ellipsis`};
            color: ${color};
            background: ${backgroundColor};
            text-transform: ${textTransform};
            border-color: ${borderColor};
            border-width: ${borderWidth};
            border-style: ${borderStyle};
            border-radius: ${borderRadius};
          }
        `}</style>
      </div>)
  }
})

export default Label
